import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { RavIconCircled } from '@shared/icon/icon';
import { MobileService } from '@shared/services/mobile.service';
import { ScopeService } from '@shared/services/scope.service';
import { ActionsComponent } from '../table/actions/actions.component';

@Component({
  selector: 'rav-actions-dropdown-menu',
  templateUrl: './actions-dropdown-menu.component.html',
  styleUrls: ['./actions-dropdown-menu.component.scss']
})
export class ActionsDropdownMenuComponent extends ActionsComponent implements OnInit {
  @ViewChild('actionsMenuTrigger', { static: true }) actionsMenuTrigger: MatMenuTrigger;

  RavIconCircled = RavIconCircled;

  constructor(scope: ScopeService, mobile: MobileService) {
    super(scope, mobile);
  }

  ngOnInit() {}
}
